import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

const listingManagerBetaRegattaFlag = 'enable_listing_manager_beta';
const listingManagerRetailRegattaFlag = 'enable_listing_manager_for_retail_venue';

export const useIsListingManagerEnabled = (venue?: Venue) => {
  const { user } = useUser();

  const { data: featureFlags, isInitialLoading } = useFeatureFlags(
    [listingManagerBetaRegattaFlag, listingManagerRetailRegattaFlag],
    {
      user_email: user?.email || '',
      user_id: user?.id || '',
      venue_id: venue?.id || '',
      venue_country: venue?.country || '',
    },
  );

  return {
    isListingManagerBetaEnabled: featureFlags?.[listingManagerBetaRegattaFlag] === 'on',
    isListingManagerExplicitlyEnabledForRetailVenue: featureFlags?.[listingManagerRetailRegattaFlag] === 'on',
    isListingManagerEnabledLoading: isInitialLoading,
  };
};
